/** Preset line items for admin quote forms (항목명 + 세부 견적 사항). */
export const QUOTE_ITEM_TEMPLATES = [
  { id: "project-planning", name: "프로젝트 기획", scope: "Project Planning" },
  { id: "content-strategy", name: "콘텐츠 전략", scope: "Content Strategy" },
  { id: "brand-identity-design", name: "브랜드 아이덴티티 및 디자인", scope: "Brand Identity & Design" },
  { id: "ui-ux-design", name: "UI/UX 디자인", scope: "UI / UX Design" },
  { id: "responsive-web-design", name: "반응형 웹 디자인", scope: "Responsive Web Design" },
  { id: "website-development", name: "홈페이지 개발", scope: "Website Development" },
  { id: "admin-cms-system", name: "관리자 / CMS 시스템", scope: "Admin / CMS System" },
  { id: "membership-system", name: "회원가입 및 로그인 시스템", scope: "Membership System" },
  { id: "reservation-system", name: "예약 시스템", scope: "Reservation System" },
  { id: "payment-system", name: "결제 시스템", scope: "Payment System" },
  { id: "customer-dashboard", name: "고객 마이페이지", scope: "Customer Dashboard" },
  { id: "crm-management", name: "고객관리 시스템", scope: "CRM Management System" },
  { id: "custom-development", name: "고급 기능 및 맞춤 개발", scope: "Advanced Features / Custom Development" },
  { id: "ai-chatbot", name: "AI 챗봇 연동", scope: "AI Chatbot Integration" },
  { id: "ai-automation", name: "AI 자동화 시스템", scope: "AI Automation System" },
  { id: "ai-video", name: "AI 영상 제작", scope: "AI Video Production" },
  { id: "api-integration", name: "외부 API 연동", scope: "API Integration" },
  { id: "seo-optimization", name: "검색엔진 최적화", scope: "SEO Optimization" },
  { id: "social-media-marketing", name: "SNS 마케팅", scope: "Social Media Marketing" },
  { id: "marketing-strategy", name: "마케팅 전략 및 분석", scope: "Marketing Strategy & Analysis" },
  { id: "hosting-deployment", name: "호스팅 및 배포", scope: "Hosting & Deployment" },
  { id: "security-ssl", name: "보안 및 SSL 구축", scope: "Security & SSL Setup" },
  { id: "maintenance-support", name: "유지보수 및 기술지원", scope: "Maintenance & Support" },
];

export function quoteItemFromTemplate(template) {
  return {
    name: template.name,
    scope: template.scope,
    duration: "",
    amount: 0,
    note: "",
    quantity: 1,
  };
}
